import { useLayoutEffect } from 'react'
import { useNavigation } from '@react-navigation/native'
import { StackScreenProps } from '@react-navigation/stack'
import { AppNavigatorParams } from '../../../navigation/types'
import { Cluster } from '../../../generated/graphql'
import { CreateArticleHeader } from '../create-article.header'

export function useArticleHeader(
  cluster: Cluster,
  onPublish: () => void,
  loading: boolean
) {
  const navigation =
    useNavigation<StackScreenProps<AppNavigatorParams>['navigation']>()

  useLayoutEffect(() => {
    navigation.setOptions({
      header: (props: any) => (
        <CreateArticleHeader
          {...props}
          cluster={cluster}
          onCancel={() => navigation.goBack()}
          onPublish={onPublish}
          loading={loading}
        />
      ),
    })
  }, [cluster, navigation, loading, onPublish])
}
